import { Controller } from 'stimulus'
import { materializeLazyCell } from '@helpers'

// A value-only cell on the account samples grid (account_samples/_cell_trait),
// and the base of lazy-result-cell on the task Results grid. On first edit,
// swap in the real inline editor cloned from its <template> and open it.
// Focus is left to inline-editable-form's connect() (its setOriginalValue rAF
// focuses the field once the .form is visible), which also fires the field's
// focus event so the outside-click-to-close listener gets registered.
export default class extends Controller {
  edit() {
    const td = this.element
    if (!materializeLazyCell(td)) {
      // Rows a reload brought in after someone changed a column can need an
      // editor this page doesn't have.
      if (window.toastr) window.toastr.warning('This grid changed since the page loaded. Reload the page to edit this cell.')
      return
    }

    const container = $(td)
    container.find('.value').hide()
    container.find('.form').show()
    container.data('keyboardNav', false)
  }
}
